import React from 'react'
import { react2angular } from 'react2angular'
import NetworkOrganizationsExporter from '@worldfavor/portal/components/Exporter/NetworkOrganizationsExporter'
import { WrapProvider } from './providers'

const props = [
    'open',
    'packages',
    'categories',
    'networkId',
    'onClosed',
]

class NetworkOrganizationsExporterWrapper extends React.Component {
    render() {
        const { wfAuth, ...rest } = this.props
        return (
            <WrapProvider wfAuth={wfAuth}>
                <NetworkOrganizationsExporter {...rest} />
            </WrapProvider>
        )
    }
}

export default react2angular(NetworkOrganizationsExporterWrapper, props, ['wfAuth'])
